var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AR_Download_on_the_App_Store",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "135px",
    height: "40px",
    viewBox: "0 0 135 40",
    enableBackground: "new 0 0 135 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.032,35.268c0,2.116-1.714,3.83-3.834,3.83H4.729c-2.119,0-3.839-1.714-3.839-3.83V4.725 c0-2.115,1.72-3.835,3.839-3.835h125.468c2.121,0,3.834,1.72,3.834,3.835L134.032,35.268L134.032,35.268z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M47.98,10.288 c0.032,0.707-0.226,1.396-0.715,1.907c-0.547,0.568-1.31,0.876-2.098,0.848c-1.658-0.013-2.992-1.368-2.979-3.026 c0.007-0.785,0.319-1.536,0.873-2.093c0.554-0.565,1.316-0.875,2.106-0.858c0.403-0.001,0.802,0.08,1.173,0.238 c0.345,0.139,0.652,0.358,0.896,0.639l-0.506,0.505c-0.386-0.458-0.965-0.709-1.563-0.677c-1.222-0.006-2.217,0.979-2.223,2.201 c0,0.029,0.001,0.058,0.001,0.087c-0.017,1.242,0.977,2.264,2.219,2.281c0.595,0.009,1.168-0.218,1.595-0.632 c0.294-0.317,0.463-0.73,0.478-1.163h-2.069V9.859h2.774C47.968,10.001,47.98,10.144,47.98,10.288z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M52.347,7.905h-2.574v1.812h2.346v0.686 h-2.346v1.812h2.574v0.706H49.01V7.2h3.337V7.905z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M55.474,12.919H54.74V7.905h-1.603V7.2h3.976 v0.705h-1.64V12.919z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M59.916,12.919V7.2h0.734v5.72H59.916z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M63.91,12.919h-0.733V7.905h-1.602V7.2h3.928 v0.705H63.91V12.919z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M72.948,12.176 c-1.16,1.154-3.034,1.154-4.194,0c-1.125-1.19-1.125-3.052,0-4.243c1.149-1.158,3.021-1.165,4.179-0.015 c0.005,0.005,0.011,0.01,0.016,0.015C74.078,9.122,74.078,10.987,72.948,12.176z M69.297,11.699c0.859,0.855,2.248,0.855,3.107,0 c0.845-0.93,0.845-2.35,0-3.28c-0.859-0.855-2.248-0.855-3.107,0C68.453,9.35,68.453,10.769,69.297,11.699z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M74.826,12.919V7.2h0.896l2.783,4.452l0,0 v-1.105V7.2h0.734v5.72h-0.763l-2.908-4.662l0,0v1.105v3.556H74.826z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M67.733,21.261c-2.237,0.011-4.043,1.834-4.032,4.071s1.833,4.043,4.071,4.032 c2.229-0.01,4.031-1.821,4.031-4.052c0.032-2.205-1.729-4.02-3.936-4.052C67.823,21.261,67.778,21.261,67.733,21.261z  M67.733,27.772c-1.354,0.096-2.53-0.927-2.625-2.282c-0.095-1.354,0.927-2.53,2.281-2.624c1.356-0.096,2.531,0.927,2.626,2.281 c0.004,0.055,0.006,0.11,0.006,0.165c0.063,1.294-0.934,2.394-2.228,2.457C67.774,27.771,67.754,27.772,67.733,27.772z  M58.858,21.261c-2.238,0.006-4.048,1.824-4.042,4.062c0.005,2.238,1.823,4.047,4.061,4.042c2.234-0.005,4.042-1.817,4.042-4.052 c0.032-2.205-1.729-4.02-3.936-4.052c-0.045,0-0.09,0-0.135,0H58.858z M58.858,27.772c-1.355,0.101-2.534-0.917-2.635-2.271 c-0.1-1.354,0.917-2.534,2.272-2.634c1.354-0.101,2.533,0.916,2.634,2.271c0.004,0.058,0.007,0.116,0.007,0.174 c0.063,1.294-0.934,2.394-2.228,2.457c-0.021,0.002-0.041,0.003-0.061,0.003H58.858z M48.285,22.511v1.716h4.119 c-0.064,0.808-0.401,1.57-0.953,2.163c-0.834,0.85-1.987,1.307-3.175,1.259c-2.527,0-4.576-2.049-4.576-4.576 s2.049-4.576,4.576-4.576c1.16-0.019,2.281,0.423,3.117,1.229l1.211-1.21c-1.14-1.154-2.697-1.797-4.319-1.783 c-3.478-0.136-6.406,2.574-6.542,6.051c-0.135,3.478,2.574,6.407,6.053,6.542c0.163,0.007,0.326,0.007,0.489,0 c1.651,0.075,3.254-0.568,4.396-1.763c0.998-1.098,1.532-2.541,1.487-4.023c0.003-0.362-0.029-0.723-0.096-1.078L48.285,22.511z  M91.48,23.845c-0.508-1.497-1.889-2.525-3.47-2.584c-2.105-0.004-3.816,1.7-3.821,3.807c0,0.082,0.003,0.163,0.008,0.245 c-0.047,2.19,1.689,4.004,3.879,4.052c0.048,0.001,0.096,0.001,0.145,0c1.354,0.008,2.623-0.666,3.375-1.792l-1.383-0.953 c-0.42,0.699-1.176,1.127-1.992,1.125c-0.845,0.032-1.624-0.455-1.964-1.229l5.425-2.241L91.48,23.845z M85.952,25.198 c-0.08-1.225,0.847-2.281,2.071-2.361c0.015-0.001,0.029-0.002,0.045-0.003c0.628-0.041,1.221,0.297,1.506,0.858L85.952,25.198z  M81.547,29.126h1.783V17.209h-1.783V29.126z M78.631,22.167h-0.067c-0.544-0.607-1.32-0.954-2.136-0.953 c-2.24,0.108-3.969,2.013-3.859,4.253c0.101,2.089,1.771,3.758,3.859,3.859c0.817,0.015,1.6-0.335,2.136-0.953h0.057v0.581 c0,1.555-0.829,2.384-2.163,2.384c-0.909-0.021-1.716-0.59-2.04-1.439l-1.555,0.648c0.599,1.456,2.021,2.402,3.595,2.393 c2.087,0,3.812-1.23,3.812-4.223V21.5h-1.639V22.167z M76.59,27.772c-1.358-0.119-2.362-1.317-2.243-2.676 c0.105-1.193,1.051-2.139,2.243-2.243c1.263,0.064,2.232,1.141,2.168,2.402c-0.001,0.019-0.002,0.038-0.004,0.057 c0.106,1.249-0.819,2.347-2.068,2.454c-0.035,0.002-0.07,0.005-0.105,0.006H76.59z M99.832,17.209h-4.261v11.917h1.782v-4.519 h2.488c2.043,0.146,3.817-1.39,3.965-3.434c0.146-2.042-1.391-3.818-3.433-3.964c-0.178-0.013-0.355-0.013-0.532,0H99.832z  M99.832,22.93h-2.488v-4.062h2.526c1.13,0,2.045,0.916,2.045,2.045c0,1.13-0.915,2.045-2.045,2.045L99.832,22.93z M110.824,21.214 c-1.326-0.08-2.573,0.636-3.175,1.82l1.583,0.658c0.318-0.588,0.954-0.932,1.62-0.877c0.941-0.11,1.794,0.563,1.904,1.505 c0.001,0.011,0.002,0.021,0.002,0.029v0.125c-0.572-0.304-1.211-0.461-1.858-0.459c-1.706,0-3.432,0.954-3.432,2.68 c0.069,1.521,1.357,2.696,2.878,2.626c0.025-0.001,0.051-0.003,0.077-0.004c0.915,0.064,1.792-0.373,2.288-1.145h0.058v0.953h1.715 V24.54c0-2.087-1.582-3.298-3.613-3.298L110.824,21.214z M110.604,27.744c-0.581,0-1.391-0.295-1.391-1.011 c0-0.953,1.01-1.268,1.906-1.268c0.566-0.014,1.126,0.124,1.62,0.399c-0.123,1.068-1.014,1.881-2.088,1.907L110.604,27.744z  M120.739,21.5l-2.04,5.167h-0.058l-2.117-5.167h-1.906l3.175,7.226l-1.812,4.014h1.859l4.881-11.239H120.739z M104.713,29.126 h1.783V17.209h-1.783V29.126z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.5166,
    y1: 63.1807,
    x2: 113.6094,
    y2: 74.0878,
    gradientTransform: "matrix(1.4667 0 0 1.4667 -159.067 -83.8334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M12.727,7.714c-0.312,0.373-0.468,0.85-0.439,1.334v21.088c-0.028,0.484,0.128,0.962,0.439,1.335 l0.066,0.066l11.812-11.802v-0.276L12.793,7.647L12.727,7.714z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.335,
    y1: 70.5186,
    x2: 116.6086,
    y2: 70.5186,
    gradientTransform: "matrix(1.4667 0 0 1.4667 -159.067 -83.8334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M28.514,23.673l-3.909-3.937v-0.276l3.909-3.947L28.6,15.56l4.681,2.66 c1.335,0.753,1.335,1.992,0,2.755l-4.662,2.65L28.514,23.673z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.4834,
    y1: 72.0107,
    x2: 111.6887,
    y2: 86.7989,
    gradientTransform: "matrix(1.4667 0 0 1.4667 -159.067 -83.8334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M28.628,23.616l-4.023-4.023L12.727,31.472c0.561,0.493,1.394,0.517,1.982,0.058l13.929-7.913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.0898,
    y1: 57.6377,
    x2: 121.6934,
    y2: 64.2412,
    gradientTransform: "matrix(1.4667 0 0 1.4667 -159.067 -83.8334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M28.628,15.569L14.699,7.657c-0.588-0.46-1.422-0.436-1.982,0.058l11.888,11.878L28.628,15.569z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    enableBackground: "new    ",
    d: "M28.514,23.529l-13.814,7.866c-0.564,0.423-1.341,0.423-1.906,0l0,0 l-0.066,0.066l0,0l0.066,0.067l0,0c0.564,0.425,1.343,0.425,1.906,0l13.929-7.913L28.514,23.529z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    enableBackground: "new    ",
    d: "M12.727,31.338c-0.312-0.372-0.468-0.85-0.439-1.335v0.144 c-0.028,0.484,0.128,0.962,0.439,1.334l0.066-0.066L12.727,31.338z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    enableBackground: "new    ",
    d: "M33.28,20.832l-4.767,2.697l0.086,0.087l4.681-2.651 c0.54-0.254,0.904-0.777,0.953-1.372l0,0C34.125,20.131,33.772,20.59,33.28,20.832z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M14.699,7.791L33.28,18.354 c0.492,0.243,0.845,0.701,0.953,1.239l0,0c-0.049-0.596-0.413-1.119-0.953-1.373L14.699,7.657 c-1.334-0.753-2.421-0.124-2.421,1.402v0.143C12.307,7.667,13.375,7.038,14.699,7.791z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e55e84bd38a77e0ebebc949972e4f97d.svg";
export { ForwardRef as ReactComponent };